"use client"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

type Props = {
  options: { key: string; label: string }[]
  value: string
  onChange: (value: string) => void
  placeholder: string
  size?: string
}

export function AdminFilterSelect({ options, value, onChange, placeholder }: Props) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger aria-label={placeholder} className="admin-filter-trigger">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent position="popper" side="bottom" align="start" sideOffset={4} collisionPadding={12} className="admin-filter-menu">
        {options.map(option => <SelectItem key={option.key} value={option.key}>{option.label}</SelectItem>)}
      </SelectContent>
    </Select>
  )
}
